export const findObjectWithHandlers = (meshObject) => {
  if (!meshObject) return null
  if (meshObject.object) {
    if (meshObject.object.hasHandlers) {
      return meshObject.object
    }
    return findObjectWithHandlers(meshObject.object.parent)
  } else if (meshObject.hasHandlers) {
    return meshObject
  } else {
    return findObjectWithHandlers(meshObject.parent)
  }
}
